/**
 * @param {number} length
 * @return {Array}
 */
export default (function (length) {
  return Array.apply(null, { length: length });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/es/utils/range.js
// module id = null
// module chunks = 